import { useEffect, useRef } from 'react';
import type { ReactElement } from 'react';
import type { ImageVideoProps } from './types';

export function ImageVideo(props: ImageVideoProps): ReactElement {
  const { src, preload = 'metadata', ...videoProps } = props;
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video == null) {
      return;
    }
    if (src != null) {
      video.src = src;
    }
    return (): void => {
      video.pause();
      video.removeAttribute('src');
      video.load();
    };
  }, [src]);

  return <video {...videoProps} ref={videoRef} preload={preload} />;
}
